import {VbMenuEntry} from "../../navigation/menu-item.interface";

export const touchStocktakingMenu: VbMenuEntry[] = [
  {
    id: 'stocktakingBack',
    title: 'Zurück zum Hauptmenü',
    icon: 'chevron-circle-left',
    link: ['/'],
    visible: true
  },
  {
    id: 'newStocktaking',
    title: 'Neue Medikamentenkontrolle',
    icon: 'box-check',
    link: ['neu'],
    visible: true
  },
  {
    id: 'continueStocktaking',
    title: 'Letzte Medikamentenkontrolle fortführen',
    icon: 'pen-square',
    link: [''],
    visible: false
  }
];


// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-stocktaking/touch-stocktaking-menu/touch-stocktaking.menu.ts